import './sass/main.scss';
import '../node_modules/@fortawesome/fontawesome-free/js/solid.min';
import '../node_modules/@fortawesome/fontawesome-free/js/fontawesome.min';
import './js/fetch_api';
import './js/rendered_cards';
import './js/to_top';
